import React from 'react';
import { Check } from 'lucide-react';

export const OrderCompleteModal = ({ tableInput, resetOrder, setViewMode, t }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-testid="order-complete-modal">
      <div className="bg-slate-800 rounded-3xl w-full max-w-sm p-8 text-center border border-slate-700">
        <div className="w-16 h-16 bg-emerald-500/20 text-emerald-400 rounded-full flex items-center justify-center mx-auto mb-4">
          <Check size={32} />
        </div>
        <h2 className="text-2xl font-black mb-2">{t.orderSent}</h2>
        <p className="text-slate-400 mb-6">{t.table} {tableInput}</p>
        <div className="space-y-3">
          <button
            onClick={() => { resetOrder(); setViewMode('menu'); }}
            className="w-full py-3 bg-amber-500 text-slate-900 rounded-xl font-black hover:bg-amber-400"
            data-testid="add-more-items-btn"
          >
            {t.addMoreItems}
          </button>
          <button
            onClick={() => { resetOrder(); setViewMode('dashboard'); }}
            className="w-full py-3 bg-slate-700 rounded-xl font-bold hover:bg-slate-600"
            data-testid="back-to-tables-btn"
          >
            {t.backToTables}
          </button>
        </div>
      </div>
    </div>
  );
};
